import React from "react";
import CircularProgress from "@material-ui/core/CircularProgress";

export default function Loader(props) {
  return (
    <React.Fragment>
      {props.Loading ? (
        <CircularProgress
          style={{
            position: "absolute",
            zIndex: 15,
            top: "50%",
            left: "50%",
          }}
        />
      ) : (
        props.children
      )}
    </React.Fragment>
  );
}
